import React from 'react';
import { TraceMetaStat } from './TraceMetaStat';

const IDE_ICON_SRC: Record<string, string> = {
  CURSOR: '/assets/ide/cursor.svg',
  CLAUDE_CODE: '/assets/ide/claude-code.svg',
  COPILOT: '/assets/ide/copilot.svg',
};

const IDE_LABEL: Record<string, string> = {
  CURSOR: 'Cursor',
  CLAUDE_CODE: 'Claude Code',
  COPILOT: 'GitHub Copilot',
};

export function ideIconSrc(ide: string): string | null {
  return IDE_ICON_SRC[ide.trim().toUpperCase()] ?? null;
}

export function ideDisplayLabel(ide: string): string {
  const key = ide.trim().toUpperCase();
  return IDE_LABEL[key] ?? ide.replace(/_/g, ' ');
}

function IdeIcon({ ide }: { ide: string }) {
  const key = ide.trim().toUpperCase();
  const iconSrc = ideIconSrc(key);
  if (!iconSrc) return null;

  if (key === 'CURSOR') {
    return (
      <span className="trace__ide-icon" aria-hidden="true">
        <img
          className="trace__ide-icon-img trace__ide-icon-img--cursor-light"
          src="/assets/ide/cursor-light.svg"
          alt=""
          width={14}
          height={14}
        />
        <img
          className="trace__ide-icon-img trace__ide-icon-img--cursor-dark"
          src="/assets/ide/cursor.svg"
          alt=""
          width={14}
          height={14}
        />
      </span>
    );
  }

  return (
    <span className="trace__ide-icon" aria-hidden="true">
      <img src={iconSrc} alt="" width={14} height={14} />
    </span>
  );
}

export const IdeMetaStat: React.FC<{ ide: string }> = ({ ide }) => {
  const label = ideDisplayLabel(ide);
  const iconSrc = ideIconSrc(ide);

  return (
    <TraceMetaStat label="IDE">
      <span className="trace__meta-value--ide">
        {iconSrc && <IdeIcon ide={ide} />}
        {label}
      </span>
    </TraceMetaStat>
  );
};
